export const documentation = {
  junior: [
    { name: 'Content Design Style Guide', url: '/docs/content-style-guide', type: 'style-guide' },
    { name: 'UX Writing Best Practices', url: '/docs/ux-writing-practices', type: 'writing' },
    { name: 'Microcopy Guidelines', url: '/docs/microcopy-guidelines', type: 'microcopy' },
    { name: 'Voice and Tone Framework', url: '/docs/voice-tone-framework', type: 'voice-tone' },
    { name: 'Content Review Process', url: '/docs/content-review-process', type: 'process' }
  ],
  mid: [
    { name: 'Advanced Content Strategy', url: '/docs/content-strategy-advanced', type: 'strategy' },
    { name: 'Content Design Systems', url: '/docs/content-design-systems', type: 'design-systems' },
    { name: 'Conversational Design Patterns', url: '/docs/conversational-design', type: 'conversational' },
    { name: 'Content Performance Measurement', url: '/docs/content-performance', type: 'metrics' },
    { name: 'Cross-platform Content Guidelines', url: '/docs/cross-platform-content', type: 'cross-platform' }
  ],
  senior: [
    { name: 'Content Leadership Framework', url: '/docs/content-leadership', type: 'leadership' },
    { name: 'Content Operations at Scale', url: '/docs/content-operations-scale', type: 'operations' },
    { name: 'AI-Assisted Content Strategy', url: '/docs/ai-content-strategy', type: 'ai-strategy' },
    { name: 'Content Governance Framework', url: '/docs/content-governance', type: 'governance' },
    { name: 'Content Team Management', url: '/docs/content-team-management', type: 'management' }
  ]
};
